import { useBizTypeTranslation } from "hooks/useBizTypeTranslation";
import { useEffect } from "react";
import TextInput from "components/files/TextInput";
import CustomIconButton from "components/CustomIconButton";
import { Add } from "@mui/icons-material";
import CustomCard from "components/CustomCard";
import { Stack, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import CustomDataGrid from "components/customDataGrid";
import { useState } from "react";
import CustomDialog from "components/CustomDialog";
import http from "../../../../http";
import { apiUrl } from "config/settings";
import { endpointName } from "containers/servicesCall/const";
import useDataManager from "hooks/useDataManager";
import { onlyNumber } from "utils/validations";

const ReplacedParts = ({ data, list, setList }) => {
    const { bt } = useBizTypeTranslation();
    const { addItem, editItem } = useDataManager();
    const { reset, handleSubmit, control, formState: { errors } } = useForm();
    const [openDialog, setOpenDialog] = useState(false)

    const openTool = (replacedPart) => {
        reset({ ...replacedPart, id: replacedPart?._id })
        setOpenDialog(true)
    }

    const onSubmitTool = (values) => {
        try {
            const replacedPart = { ...values }
            http.patch(`${apiUrl}/${endpointName}/${values?.id ? "createReplacedParts" : "createReplacedParts"}/${data?.id}`, replacedPart)
                .then(res => {
                    if (res?.status === 200) {
                        if (replacedPart?.id) setList(editItem(replacedPart, list))
                        else setList(addItem(res?.data, list))
                    }
                })
            closeDialog()

        }
        catch (error) {
            console.log("error", error);
        }
    }

    const closeDialog = () => {
        reset({ name: "", qty: null })
        setOpenDialog(false)
    }

    return (
        <CustomCard width="100%">
            <Stack direction="row" spacing={1} alignItems="center" justifyContent="space-between">
                <Typography fontSize={14}>{bt("REPLACED_PARTS")}:</Typography>
                <CustomIconButton hideBgcolor icon={<Add />} size={30} onClick={() => setOpenDialog(true)} />
            </Stack>

            <CustomDataGrid
                width="100%"
                minHeight={50}
                setItem={(i) => openTool(i)}
                list={list?.map((w) => ({ ...w, id: w?._id, })
                )}
                columns={[
                    {
                        field: 'name',
                        headerName: bt("NAME"),
                        width: 200,
                        filterable: false,
                    },
                    {
                        field: 'qty',
                        headerName: bt("QTY"),
                        width: 100,
                        filterable: false,
                    },
                ]}
                hideFooter
            />

            <CustomDialog
                title="TOOLS"
                open={openDialog}
                onClose={() => closeDialog()}
                actionBtn={{ title: bt("SAVE"), onClick: () => handleSubmit(onSubmitTool)() }}
            >
                <form onSubmit={handleSubmit(onSubmitTool)}>

                    <Stack spacing={2}>
                        <TextInput
                            control={control}
                            name={`name`}
                            title="NAME"
                        />

                        <TextInput
                            control={control}
                            name={`qty`}
                            title="QTY"
                            validation={onlyNumber}
                        />
                    </Stack>

                </form>
            </CustomDialog>
        </CustomCard>
    )
};

export default ReplacedParts;
